import React from 'react';
import { Editor } from '@tiptap/react';

import { Button } from 'containers/Tiptap/components/tiptap-ui-primitive/button';
import { acceptPendingAi, rejectPendingAi, selectionOverlapsAiChange } from 'containers/Tiptap/lib/ai-utils';

import { colors } from 'theme/colors';

interface AIActionsSectionProps {
  editor: Editor;
  isGenerating: boolean;
}

const AIActionsSection: React.FC<AIActionsSectionProps> = ({ editor, isGenerating }) => {
  const handleAccept = (): void => {
    acceptPendingAi(editor);
  };

  const handleReject = (): void => {
    rejectPendingAi(editor);
  };

  if (isGenerating) {
    return (
      <Button disabled style={{ padding: '18px 12px', fontSize: '16px' }} type="button">
        <h2>Loading...</h2>
      </Button>
    );
  }

  if (!selectionOverlapsAiChange(editor)) {
    return null;
  }

  return (
    <>
      {editor.can().aiAccept() && (
        <Button
          onClick={handleAccept}
          style={{
            backgroundColor: 'rgb(36, 152, 85)',
            color: colors.common.white,
            borderRadius: '4px',
            width: '120px',
          }}
        >
          Accept
        </Button>
      )}
      {editor.can().aiReject() && (
        <Button
          style={{
            backgroundColor: 'rgb(231, 76, 60)',
            color: colors.common.white,
            borderRadius: '4px',
            width: '120px',
          }}
          onClick={handleReject}
        >
          Reject
        </Button>
      )}
    </>
  );
};

export default AIActionsSection;
